/** ======================================= 注意，此文件为自动生成，不要手动修改！！================================ **/
import {base} from '../../../base';

export const infos = {
  'cartAdd': {
    '__proto__': base,
    'name': 'cartAdd',
    'desc': " [商城模块]添加购物车",
    'url': '/api/cart/add',
    'args': {
      product_sku_id: {
        'pos': 0,
        'desc': "商品SKUID",
        'demo': '',
      },
      quantity: {
        'pos': 1,
        'desc': "商品数量",
        'demo': '',
      },

    },
    'returns': "{Promise<*>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"info\": []\n }\n}\n",
  },
  'cartCount': {
    '__proto__': base,
    'name': 'cartCount',
    'desc': " [商城模块]统计购物车数量",
    'url': '/api/cart/count',
    'args': {

    },
    'returns': "{Promise<any>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"info\": {\n     \"quantity_count\": 1\n   }\n }\n}\n",
  },
  'cartList': {
    '__proto__': base,
    'name': 'cartList',
    'desc': " [商城模块]购物车列表",
    'url': '/api/cart/list',
    'args': {
      pageSize: {
        'pos': 0,
        'desc': "分页显示数据条数 默认10",
        'demo': '',
      },
      page: {
        'pos': 1,
        'desc': "分页页码 默认1",
        'demo': '',
      },

    },
    'returns': "{Promise<any>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"totalPage\": 1,\n   \"currentPage\": 1,\n   \"info\": [\n     {\n       //商品信息\n       \"product\": {\n         //商品ID\n         \"id\": \"12048\",\n         //商品名称\n         \"title\": \"猪头肉\",\n         //计量单位\n         \"unit\": \"斤\",\n         //状态 1=上架 2=下架\n         \"status\": \"1\",\n         //删除时间 (注意:前端根据本字段判断商品是否被删除,0:未删除 !0:已删除)\n         \"delete_time\": \"0\"\n       },\n       //商品SKU列表,，包含多个对象，每个对象字段如展开所示\n       \"product_sku_list\": [\n         {\n           //商品SKUID\n           \"id\": \"3756\",\n           //商品SKU的规格,包含多个对象，每个对象字段如展开所示\n           \"product_spec\": [\n             {\n               \"product_spec_key\": {\n                 \"id\": 517,\n                 \"title\": \"颜色\"\n               },\n               \"product_spec_value\": {\n                 \"id\": 945,\n                 \"value\": \"蓝\"\n               }\n             }\n           ],\n           //状态 1=正常 2=禁用\n           \"status\": \"1\",\n           \"price\": \"80\",\n           //购物车数量\n           \"cart_sku_quantity\": \"1\"\n         }\n       ],\n       //\t商品图片\n       \"productImages\": {\n         //图片类型 1=商品入户图 2=商品bannner图 3=商品介绍图\n         \"type\": \"1\",\n         \"url\": \"https://admin.bb.uninote.com.cn/oss?path=uploads/images/2020/12/f1cecad5ef235345f04934a9bacef0ef.png\"\n       },\n       //商品促销活动\n       \"__productPromotion\": \"i\",\n       \"productPromotion\": {\n         //促销活动ID\n         \"id\": \"7\",\n         //开始时间\n         \"start_time\": \"1606550460\",\n         //结束时间\n         \"end_time\": \"1606550460\",\n         //限购数量(注意: 这里是每个用户的限购数量, 不是每次限购数量)\n         \"limit_number\": \"5\",\n         //商品促销活动sku\n         \"productPromotionSku\": [\n           {\n             //商品skuid\n             \"product_sku_id\": \"3756\",\n             //促销价格\n             \"promotion_price\": \"10\",\n             //促销数量\n             \"promotion_number\": \"10\",\n             //实际销售数量\n             \"used_number\": \"0\"\n           }\n         ],\n         //用户已参与过本活动的数量(如果本字段的值为1,活动的限购数量字段limit_number为2,说明当前用户还可以参与本活动1个数量,如果本字段的值为2,说明当前用户不可以参与本活动了,已经达到活动的限购数量了1个数量)\n         \"used_number\": 2\n       }\n     }\n   ]\n }\n}\n",
  },
  'cartDel': {
    '__proto__': base,
    'name': 'cartDel',
    'desc': " [商城模块]删除购物车",
    'url': '/api/cart/del',
    'args': {
      product_sku_id: {
        'pos': 0,
        'desc': "商品SKUID",
        'demo': '',
      },
      quantity: {
        'pos': 1,
        'desc': "商品数量(0为删除,非0为减少数量,注意,数量减少到1将不能再减少)",
        'demo': '',
      },

    },
    'returns': "{Promise<*>}\n{\n \"code\": 1,\n \"message\": \"success!\",\n \"data\": {\n   \"info\": []\n }\n}\n",
  }
};
